import React from 'react';
import {connect} from 'react-redux';
import {
  getError,
  getOrderIntent,
  getPaymentInstrument, getProduct,
  getResult,
  getThreeDsAuthenticationResult, isExecutionRequired,
} from "./ResultReducers";
import {UrlUtils} from '../utils/UrlUtils';
import {AuthorizationUtils} from "../utils/AuthorizationUtils";
import {receive} from './ResultActions';

const ResultContainer = ({result, error, orderIntent, threeDsAuthenticationResult, paymentInstrument, config, receive, isExecutionRequired, product}) => {
  let orderDetails = !orderIntent ? null : {
    orderId: orderIntent.orderId,
    merchantOrderId: orderIntent.merchantOrderId,
    paymentProviderTransactionId: orderIntent.paymentProviderTransactionId,
    ...orderIntent
  };
  const successExecuteCallback = (error) => {
    if (error) {
      alert("Error while executing the transaction");
    } else {
      alert('Order executed!');
      fetch(`${config.api.baseUrl}/orders/${orderDetails.orderId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': AuthorizationUtils.base64(config.environment.merchantId, config.environment.apiKey)
        }
      })
        .then(response => response.json())
        .then(response => {
          receive(error, result, response, threeDsAuthenticationResult, paymentInstrument);
        });
    }
  };

  const executeOrder = () => {
    const productParam = result && result.confirmUrl ? UrlUtils.getParamValue(result.confirmUrl, 'product') : product;
    window.PayEngineWidget.executeOrder(productParam, orderIntent.merchantId, orderIntent.orderId, successExecuteCallback);
  };

  return (
    <div>
      <div className="col-xs-6">
        <div>
          <h3>Error</h3>
          <pre>{JSON.stringify(error, null, 2)}</pre>
        </div>
        {
          ((result && result.confirmUrl && !result.orderId) || isExecutionRequired) &&
          <button className="btn btn-primary col-xs-12" type="button" onClick={executeOrder}>
            Execute order
          </button>
        }
      </div>
      <div className="col-xs-6">
        <div>
          <h3>Result</h3>
          <pre>{JSON.stringify(result, null, 2)}</pre>
        </div>
        {orderDetails && <div>
          <h3>Order Details</h3>
          <pre>{JSON.stringify(orderDetails, null, 2)}</pre>
        </div>}
        {paymentInstrument && <div>
          <h3>Payment Instrument Final</h3>
          <pre>{JSON.stringify(paymentInstrument, null, 2)}</pre>
        </div>}
        {threeDsAuthenticationResult && <div>
          <h3>3DS Authentication Result</h3>
          <pre>{JSON.stringify(threeDsAuthenticationResult, null, 2)}</pre>
        </div>}
      </div>
    </div>
  );
};

ResultContainer.propTypes = {
};

const mapStateToProps = (state) => ({
  result: getResult(state),
  isExecutionRequired: isExecutionRequired(state),
  product: getProduct(state),
  error: getError(state),
  orderIntent: getOrderIntent(state),
  threeDsAuthenticationResult: getThreeDsAuthenticationResult(state),
  paymentInstrument: getPaymentInstrument(state),
  config: state.app.config
});

export default connect(
  mapStateToProps,
  {receive}
)(ResultContainer);



// WEBPACK FOOTER //
// ./src/result/ReesultContainer.js